export function searchMissingNumber(arr: number[]) {
    for (let i = 0; i < arr[arr.length - 1]; i++) {
        if ((i + 1) !== arr[i]) {
            return i + 1
        }
    }
}
